export * from "./ng-tci-pipe.module";
export * from "./ng-tci-date.pipe";
